var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgItemAttributesBeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99993 2C6.80218 2.00004 6.60888 2.05871 6.44447 2.1686C6.28006 2.27848 6.15193 2.43465 6.07626 2.61735C6.00059 2.80005 5.98078 3.00108 6.01935 3.19503C6.05792 3.38898 6.15312 3.56715 6.29293 3.707L6.99993 4.414V8.172C6.99988 8.43719 6.89448 8.69151 6.70693 8.879L2.70693 12.879C0.816934 14.769 2.15593 18 4.82793 18H15.1709C17.8439 18 19.1829 14.769 17.2929 12.879L13.2929 8.879C13.1054 8.69151 13 8.43719 12.9999 8.172V4.414L13.7069 3.707C13.8467 3.56715 13.9419 3.38898 13.9805 3.19503C14.0191 3.00108 13.9993 2.80005 13.9236 2.61735C13.8479 2.43465 13.7198 2.27848 13.5554 2.1686C13.391 2.05871 13.1977 2.00004 12.9999 2H6.99993ZM8.99993 8.172V4H10.9999V8.172C11.0004 8.96724 11.3165 9.72977 11.8789 10.292L12.9059 11.32C12.1867 11.153 11.4353 11.1883 10.7349 11.422L10.2649 11.578C9.44381 11.8517 8.55606 11.8517 7.73493 11.578L7.17193 11.391C7.13429 11.3782 7.09627 11.3665 7.05793 11.356L8.12093 10.293C8.68358 9.73052 8.99976 8.96758 8.99993 8.172Z",
    fill: "#06D6A0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemAttributesBeaker);
export default __webpack_public_path__ + "static/media/item-attributes-beaker.a6dedc2f39630ce46306a7b922f4bc6b.svg";
export { ForwardRef as ReactComponent };